export default __webpack_public_path__ + "static/media/DNo.21-0.d0b999ed.jpg";